import { mapGetters, mapActions } from 'vuex'

import i18n from '_/i18n'

import Vue from 'vue'

import sessionChecker from '_/helpers/sessionChecker'

import {
  Assets,
  MainMenu,
  QuickLaunch,
  TitleBar,
  UserMenu,
  SessionModal,
} from '@/components'

import DashboardRoute from '_/components/Dashboard/Dashboard.route'

const DashboardWidgets = Vue.component(
  'DashboardWidgets',
  require('_/components/Dashboard/Widgets/DashboardWidgets.vue').default
)

export default {
  /**
   * Set route handler
   *
   * @type {function}
   */
  route: DashboardRoute,

  /**
   * Set the component's data storage
   *
   * @return  {void}
   */
  data: function() {
    return {
      /**
       * Session checker interval id
       *
       * @type  {number}
       */
      sessionCheckerIntervalId: null,
    }
  },

  components: {
    Assets,
    DashboardWidgets,
    'main-menu': MainMenu,
    UserMenu,
    TitleBar,
    QuickLaunch,
    SessionModal,
  },

  /**
   * Set the computed variables
   *
   * @type  {object}
   */
  computed: mapGetters({
    user: 'user/user',
  }),

  /**
   * Set the methods
   *
   * @type {Object}
   */
  methods: {
    /**
     * Map actions from ui module namespace
     */
    ...mapActions('ui', ['animateWrapper', 'setBodyClass', 'setTitle']),
  },

  /**
   * Call a mounted hook
   *
   * @type {function}
   * @return  {void}
   */
  mounted() {
    this.$nextTick(function() {
      this.setBodyClass('dashboard-page')

      this.setTitle(i18n.t('errors.dashboard'))

      this.animateWrapper()

      this.sessionCheckerIntervalId = sessionChecker.setCheckerInterval()
    })
  },

  /**
   * Set the beforeDestroy hook
   *
   * @return  {void}
   */
  beforeDestroy() {
    clearInterval(this.sessionCheckerIntervalId)

    this.sessionCheckerIntervalId = null
  },
}
